compiler('.mutual-exclusive-check-boxes', (element) => {
  const checkBoxes = element.querySelectorAll('input[type="checkbox"]')
  checkBoxes.forEach((checkBox) => {
    checkBox.addEventListener('change', (event) => {
      checkBoxes.forEach((otherCheckBox) => {
        if (otherCheckBox !== checkBox) {
          otherCheckBox.checked = false
        }
      })
    })
  })
})
